var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMovementAnalysisFineMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_5694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9224 26.2305H13.9714V27.6074H20.9224V26.2305Z",
    fill: "#3BB1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9224 28.9844H13.9714V30.3613H20.9224V28.9844Z",
    fill: "#3BB1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6378 11.0843L27.5952 12.117L32.1132 16.5921H23.6609C23.3412 13.7143 21.0335 11.4423 18.1419 11.1256V2.75387L22.66 7.22892L23.7026 6.19621L17.4468 0L11.191 6.19621L12.2336 7.22892L16.7517 2.75387V11.1256C13.8601 11.4423 11.5524 13.7143 11.2327 16.5921H2.78037L7.29847 12.117L6.25583 11.0843L0 17.2806L6.25583 23.4768L7.29847 22.4441L2.78037 17.969H11.191V40H23.7026V17.969H32.1132L27.5952 22.4441L28.6378 23.4768L34.8936 17.2806L28.6378 11.0843ZM22.3125 38.6231H12.5812V17.2943C12.5812 14.6231 14.7638 12.4613 17.4468 12.4613C20.1299 12.4613 22.3125 14.6231 22.3125 17.2943V38.6231Z",
    fill: "#3BB1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4469 13.8379C15.5284 13.8379 13.9714 15.3938 13.9714 17.294V22.0995H20.9224V17.294C20.9224 15.3801 19.3792 13.8379 17.4469 13.8379ZM19.5322 20.7226H15.3616V17.2802C15.3616 16.1511 16.293 15.2148 17.4469 15.2148C18.6007 15.2148 19.5322 16.1374 19.5322 17.2802V20.7226Z",
    fill: "#3BB1E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_5694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8936,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementAnalysisFineMotor);
export default __webpack_public_path__ + "static/media/movement_analysis_fine_motor.2adc4c6b960a536e446c0cd607192169.svg";
export { ForwardRef as ReactComponent };